var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMassiveDup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.31818 9.95455H1.18182C0.868381 9.95455 0.56778 9.83003 0.346146 9.6084C0.124513 9.38676 0 9.08616 0 8.77273V1.68182C0 1.36838 0.124513 1.06778 0.346146 0.846147C0.56778 0.624513 0.868381 0.5 1.18182 0.5H8.27273V1.68182H1.18182V8.77273H5.31818V7.59091L7.68182 9.36364L5.31818 11.1364V9.95455ZM10.0455 12.3182V4.04545H3.54545V7.59091H2.36364V4.04545C2.36364 3.73202 2.48815 3.43142 2.70978 3.20978C2.93142 2.98815 3.23202 2.86364 3.54545 2.86364H10.0455C10.3589 2.86364 10.6595 2.98815 10.8811 3.20978C11.1028 3.43142 11.2273 3.73202 11.2273 4.04545V12.3182C11.2273 12.6316 11.1028 12.9322 10.8811 13.1539C10.6595 13.3755 10.3589 13.5 10.0455 13.5H3.54545C3.23202 13.5 2.93142 13.3755 2.70978 13.1539C2.48815 12.9322 2.36364 12.6316 2.36364 12.3182V11.1364H3.54545V12.3182H10.0455Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMassiveDup);
export default __webpack_public_path__ + "static/media/icon--massive-dup.5631d4fa645b57da7af295fd54f96a82.svg";
export { ForwardRef as ReactComponent };